import React, { Component } from "react";
import { connect } from "react-redux";

import Spinner from "../../components/generics/Spinner";
import _ from "lodash";

import {
  SCAN_SCANNING,
  SCAN_OK,
  SCAN_ERROR,
} from "../../components/generics/QRScanner";
import { Collapse } from "react-collapse";

import AddInventoryWidget from "../../components/generics/AddInventoryWidget";
import LocatedItemsList from "../../components/inventories/LocatedItemsList";
import GenericDropdown from "../../components/generics/GenericDropdown";

import Alert from "../../utils/Alert";

import {
  fetchLocations,
  fetchLocationsSuccess,
  fetchLocationsFailure,
} from "../../store/inventories/actions";

import {
  getInventory,
  updateInventoriesLocation,
} from "../../store/inventories/api";
import { withRouter } from "utils/WithRouter";

export class InventoryLocationsEditContainer extends Component {
  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props) {
    super(props);

    this.state = {
      locationIndex: -1,
      currentLocation: undefined,
      scannedItems: [],
      scanResult: undefined,
      scanStatus: SCAN_SCANNING,
      loading: false,
      errors: [],
      itemsToLocate: [],
      inventoryId: "",
    };

    this.alertRef = React.createRef();
  }

  componentDidMount() {
    this.props.fetchLocations();
  }

  spliceError = (element) => {
    var errors = this.state.errors.slice();
    var index = errors.indexOf(element);
    if (index !== -1) {
      errors.splice(index, 1);
    }
    return errors;
  };

  onLocationChange = (event) => {
    let errors = [],
      locationIndex = event.target.value,
      currentLocation = this.props.locationsList.locations[locationIndex];

    if (locationIndex > -1) {
      errors = this.spliceError("location");
    } else {
      errors = this.state.errors;
      if (errors.indexOf("location") === -1) {
        errors.push("location");
      }
    }
    this.setState({ locationIndex, currentLocation, errors });
  };

  // ---------------------------------------------------------------------------
  // Items
  // ---------------------------------------------------------------------------
  onItemIdChange = (event) => {
    this.setState({ inventoryId: event.target.value });
  };

  handleAddInventory = () => {
    let inventoryId = this.state.inventoryId,
      itemsToLocate = this.state.itemsToLocate,
      index = -1;

    const ids = inventoryId.split("-");
    if (ids.length && parseInt(ids[0], 10) > parseInt(ids[1], 10)) {
      this.alertRef.current.sendAlert(
        `The range must be from start to end #${inventoryId}`,
        "error"
      );
      return;
    }

    if (inventoryId) {
      this.setState({ loading: true, inventoryId: "" }, () => {
        getInventory(inventoryId, true)
          .then((resp) => {
            let items = resp.data;
            items.map((item) => {
              index = itemsToLocate.findIndex((itemToLocate) => {
                return parseInt(item.id, 10) === itemToLocate.id;
              });
              if (index === -1) {
                item.new_location = this.state.currentLocation;
                itemsToLocate.push(item);
                this.setState(
                  { loading: false, inventoryId: "", itemsToLocate },
                  () => {}
                );
              } else {
                this.alertRef.current.sendAlert(
                  `Item #${item.id} has been already located!`
                );
                this.setState({ loading: false, inventoryId: "" });
              }
            });
            this.alertRef.current.sendAlert(
              `Inventories #${items.map(
                (item) => item.id
              )} successfully added to ${this.state.currentLocation.name}`,
              "success"
            );
          })
          .catch((err) => {
            this.setState({ loading: false, inventoryId: "" }, () => {
              this.alertRef.current.sendAlert(
                `Cannot add Inventory #${inventoryId} to ${this.state.currentLocation.name}`
              );
            });
          });
      });
    }
  };

  handleDeleteInventory = (index) => {
    this.setState({ loading: true });
    let itemsToLocate = this.state.itemsToLocate;
    if (index !== -1) {
      itemsToLocate.splice(index, 1);
    }
    this.setState({ itemsToLocate, loading: false });
  };

  // ---------------------------------------------------------------------------
  // Scanned Items
  // ---------------------------------------------------------------------------

  handleScannedItem = (scan) => {
    const scannedId = scan;
    this.setState(
      {
        scanResult: `Scanned item #${scannedId}`,
        scanStatus: SCAN_OK,
      },
      () => {
        if (scannedId) {
          getInventory(scannedId, true)
            .then((resp) => {
              let itemsToLocate = this.state.itemsToLocate,
                index = itemsToLocate.findIndex((item) => {
                  return parseInt(scannedId, 10) === item.id;
                });
              if (index === -1) {
                let items = resp.data;
                items.map((item) => {
                  item.new_location = this.state.currentLocation;
                  itemsToLocate.push(item);
                  this.setState(
                    { loading: false, scannedId: "", itemsToLocate },
                    () => {
                      this.alertRef.current.sendAlert(
                        `Inventory #${scannedId} successfully added to ${this.state.currentLocation.name}`,
                        "success"
                      );
                    }
                  );
                });
              } else {
                this.alertRef.current.sendAlert(
                  "Item has been already located!"
                );
              }
              setTimeout(this.cleanMessage, 1500);
            })
            .catch((err) => {
              this.setState(
                {
                  scanResult: `Cannot add Inventory #${scannedId}`,
                  scanStatus: SCAN_ERROR,
                },
                () => {}
              );
              setTimeout(this.cleanMessage, 1500);
            });
        }
      }
    );
  };

  handleScanError = () => {
    this.setState({ scanStatus: SCAN_ERROR, scanResult: "Cannot scan" });
  };

  cleanMessage = () => {
    this.setState({ scanStatus: SCAN_SCANNING, scanResult: "" });
  };

  save = () => {
    let itemsToLocate = this.state.itemsToLocate.slice(),
      data = { inventories_to_locate: {} },
      groupedItemsByLocation = _.groupBy(itemsToLocate, "new_location.id");

    if (itemsToLocate.length > 0) {
      this.setState({ loading: true });
      _.each(_.keys(groupedItemsByLocation), (key) => {
        data.inventories_to_locate[key] = [];
        groupedItemsByLocation[key].forEach((item) => {
          data.inventories_to_locate[key].push({ id: item.id });
        });
      });

      updateInventoriesLocation(data)
        .then((r) => {
          this.alertRef.current.sendAlert(
            "Items have been moved to the selected locations!",
            "success"
          );
          this.setState({ loading: false, itemsToLocate: [] }, () => {
            this.props.history.push("/inventory/locations/");
          });
        })
        .catch((err) => {
          this.setState({ loading: false });
        });
    }
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    if (this.props.locationsList.loading) {
      return (
        <div>
          <Alert ref={this.alertRef} />
          <Spinner />
        </div>
      );
    } else {
      let header = {
          border: "1px solid #dbdee0",
          borderBottom: "none",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0.75rem 1.25rem",
          background: "#f9f9f9",
        },
        addInventoriesCard = { borderTop: "none", background: "white" };
      return (
        <div>
          <Alert ref={this.alertRef} />
          <div style={header}>
            <span className="d-flex align-items-center">
              <i className="fa fa-thumb-tack mr-05"></i>
              <h5 className="m-0">Locate Inventory Items</h5>
            </span>
            <div>
              <button
                className="btn btn-md btn-success m-0"
                onClick={() => {
                  this.save();
                }}
              >
                Save
              </button>
            </div>
          </div>

          <div className="mb-1">
            <GenericDropdown
              list={this.props.locationsList.locations}
              disableMarginBottom={true}
              disableBorderBottom={
                parseInt(this.state.locationIndex, 10) !== -1
              }
              backgroundColor={"white"}
              value={this.state.locationIndex}
              onSelectChange={this.onLocationChange}
              text={"Location"}
              emptySelectMsg={"-- Select location --"}
              dropdownError={this.state.errors.indexOf("location") !== -1}
            />

            <Collapse isOpened={parseInt(this.state.locationIndex, 10) !== -1}>
              <div
                className="card-block border-gray"
                style={addInventoriesCard}
              >
                {this.state.loading ? <Spinner /> : ""}
                <div>
                  <h6>Add inventory items</h6>
                  <AddInventoryWidget
                    inputVal={this.state.inventoryId}
                    onInputChange={this.onItemIdChange}
                    onSubmit={this.handleAddInventory}
                    onScanItem={this.handleScannedItem}
                    onScanError={this.handleScanError}
                    scannedItems={this.state.scannedItems}
                    scanResult={this.state.scanResult}
                    scanStatus={this.state.scanStatus}
                    blocked={parseInt(this.state.locationIndex, 10) === -1}
                  />
                </div>
              </div>
            </Collapse>
          </div>

          <LocatedItemsList
            title={"Items to Locate"}
            onDelete={this.handleDeleteInventory}
            inventories={this.state.itemsToLocate}
          />
        </div>
      );
    }
  }
}

// ---------------------------------------------------------------------------
// Redux
// ---------------------------------------------------------------------------
const mapStateToProps = (state, ownProps) => {
  return {
    locationsList: state.inventories.locationsList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchLocations: (id, props) => {
      dispatch(fetchLocations(id)).payload.then(
        (response) => {
          dispatch(fetchLocationsSuccess(response.data));
        },
        (error) => {
          dispatch(fetchLocationsFailure(error));
        }
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(InventoryLocationsEditContainer));
